export default __webpack_public_path__ + "static/media/home.69a10d5a.svg";